import { render, staticRenderFns } from "./ChannelStep.vue?vue&type=template&id=d189fd44&"
import script from "./ChannelStep.vue?vue&type=script&lang=js&"
export * from "./ChannelStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d189fd44')) {
      api.createRecord('d189fd44', component.options)
    } else {
      api.reload('d189fd44', component.options)
    }
    module.hot.accept("./ChannelStep.vue?vue&type=template&id=d189fd44&", function () {
      api.rerender('d189fd44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/ChannelStep.vue"
export default component.exports